module.exports = __webpack_public_path__ + "static/media/calendar-day.cfa49365.svg";